<template>
  <div class="box">
    <v-server-table
      ref="datatable" 
      :url="api" 
      :name="tableName" 
      :columns="columns" 
      :options="options">

      <template
        slot="code"
        slot-scope="props">
        <i
          v-if="props.row.code == null"
          class="text-muted">Empty</i>
        <span v-else>{{ props.row.code }}</span>
      </template>

      <template
        slot="parent"
        slot-scope="props">
        <i
          v-if="props.row.parent == null">{{ trans('tag.no_parent_tag_assigned') }}</i>
        <span v-else>{{ props.row.parent.name }}</span>
      </template>

      <template
        slot="items"
        slot-scope="props">
        <collection-counter
          :collection="props.row.products"
          label="name"
          subject="products assigned" />
      </template>

      <template
        slot="modifier_sets"
        slot-scope="props">
        <collection-counter
          :collection="props.row.modifier_sets"
          label="name"
          subject="modifiers assigned" />
      </template>
    </v-server-table>

    <div 
      id="tag-popup" 
      class="modal fade inactive" 
      data-backdrop="false">
      <div class="right w-xxxl white b-l">
        <vuetabletag_form
          :tag="tag"
          @tag-saved="fetchData"
          @showupProduct="showProduct($event)"
        />
      </div>
    </div>

    <div 
      id="product-popup" 
      class="modal fade inactive" 
      data-backdrop="true">
      <product_list 
        :tag="tag"
        :title="`${trans('tag.apply_tags_to_product')}`"
        @updateProduct="updateProduct($event)"
      />
    </div>

  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import CollectionCounter from '@js/components/collection-counter';

const exportUrl = 'franchise.inventory.tags.exportAsFile';

export default {
    components: {
        CollectionCounter,
    },

    data() {
        var that = this;
        let canManageItems = Auth.hasAnyPermission(
            'franchise_manage_items',
            'franchise_manage_tags',
        );

        let actionButtons = [
            {
                title: this.trans('tag.create_tag'),
                action: () => {
                    this.show_popup(null);
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        return {
            tag: {},
            products: {},
            tableName: 'VUETABLE_TAG',
            api: Laroute.route('franchise.inventory.tags.vue.getvuetabletag'),
            columns: ['name', 'code', 'parent', 'items', 'modifier_sets'],
            options: {
                checkbox: canManageItems,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.tags.delete',
                    ),
                    delete_title: this.trans('tag.delete_tag'),
                },
                sortable: ['name', 'code'],
                orderBy: { column: 'name', ascending: 1 },
                texts: {
                    count:
                        'Showing {from} to {to} of {count} records|{count} records|One record',
                    limit: 'Records per page :',
                    filterPlaceholder: this.trans('tag.search_tag'),
                },
                headings: {
                    name: 'Name',
                    parent: this.trans('tag.parent_tag'),
                    items: 'Products',
                    modifier_sets: 'Modifiers',
                },
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                actionButtons: actionButtons,

                rowClassCallback: row => {
                    let clazz = ['pointer'];

                    if (row.status == 0) {
                        clazz.push('text-muted');
                    }

                    return clazz;
                },

                rowClickCallback: that.show_popup,
            },
        };
    },

    created() {
        this.init_tag();
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        init_tag() {
            this.tag = {
                id: 0,
                name: '',
                code: null,
                parent_id: null,
                description: '',
                products: [],
                modifier_sets: [],
                parent: null,
                hidden_tag: false,
                hidden_products: false,
            };
        },

        get_tag(id) {
            var that = this;
            this.$http.get(this.getTagApi(id)).then(response => {
                that.tag = response.data.data;
                that.show_modal();
            });
        },

        show_popup(row) {
            if (row != null) {
                this.get_tag(row.id);
            } else {
                this.init_tag();
                this.show_modal();
            }
        },

        show_modal() {
            $('#tag-popup').modal('show');
        },

        showProduct(row) {
            this.data = row;
            this.show_product_modal();
        },

        show_product_modal() {
            $('#product-popup').modal('show');
        },

        updateProduct(row) {
            this.tag.products = row;
        },

        getTagApi(id) {
            return Laroute.route('franchise.inventory.tags.show', { id: id });
        },

        fetchData() {
            this.$refs.datatable.getData();
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 20;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/vuetable_tag.vue